export default __webpack_public_path__ + "869361413d65a509a2c3534a713043ff.png";